import {
  Box, Button, ButtonGroup, Checkbox, FormControl, FormLabel, Grid, GridItem, Input, Select, Textarea, VStack
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { CUSTOMER_PROVIDING_DEPOSIT, QUOTE_PAYMENT_TERMS_OPTIONS } from 'lib'

export const defaultAccountingInfo = (paymentTerms = '') => ({
  customerPo: '',
  isIndividualSchool: false,
  schoolDistrictName: '',
  alternateAccountingContact: '',
  expectedPaymentTerms: paymentTerms || '',
  customerProvidingDeposit: CUSTOMER_PROVIDING_DEPOSIT.Unknown,
  accountingNotes: ''
})

export const AccountingInfoStep = ({ form, setForm, onPrev, onNext, isSubmitting, ...rest }) => {
  const accountingInfo = form.accountingInfo || defaultAccountingInfo()

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(draft => {
      draft.accountingInfo[name] = value
    })
  }

  const handleSchoolToggle = (e) => {
    const checked = e.target.checked
    setForm(draft => {
      draft.accountingInfo.isIndividualSchool = checked
      if (!checked) draft.accountingInfo.schoolDistrictName = ''
    })
  }

  const handleTaxExemptionChange = (e) => {
    const file = e.target.files?.[0] || null
    setForm(draft => {
      draft.taxExemption = file
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onNext()
  }

  return (
    <Box {...rest}>
      <form onSubmit={handleSubmit}>
        <VStack gap={4} align="stretch">
          <Grid templateColumns="1fr 1fr" columnGap={5} rowGap={2}>
            <GridItem>
              <FormControl>
                <FormLabel>PO (if available)</FormLabel>
                <Input name="customerPo" value={accountingInfo.customerPo} onChange={handleChange} />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Tax Exemption (if available)</FormLabel>
                <Input type="file" name="taxExemption" accept=".pdf,.jpg,.jpeg,.png" onChange={handleTaxExemptionChange} p={1} />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl isRequired>
                <FormLabel>Expected Payment Terms</FormLabel>
                <Select name="expectedPaymentTerms" value={accountingInfo.expectedPaymentTerms} onChange={handleChange}>
                  <option value="">Select payment terms</option>
                  {Object.keys(QUOTE_PAYMENT_TERMS_OPTIONS).map(key => (
                    <option key={key} value={QUOTE_PAYMENT_TERMS_OPTIONS[key]}>{QUOTE_PAYMENT_TERMS_OPTIONS[key]}</option>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl isRequired>
                <FormLabel>Is customer providing a deposit?</FormLabel>
                <Select name="customerProvidingDeposit" value={accountingInfo.customerProvidingDeposit} onChange={handleChange}>
                  {Object.keys(CUSTOMER_PROVIDING_DEPOSIT).map(key => (
                    <option key={key} value={CUSTOMER_PROVIDING_DEPOSIT[key]}>{CUSTOMER_PROVIDING_DEPOSIT[key]}</option>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem colSpan={2}>
              <FormControl>
                <FormLabel>Alternate Accounting Contact (if provided)</FormLabel>
                <Input name="alternateAccountingContact" value={accountingInfo.alternateAccountingContact} onChange={handleChange} placeholder="Name, email, phone" />
              </FormControl>
            </GridItem>
            <GridItem colSpan={2}>
              <FormControl>
                <Checkbox isChecked={accountingInfo.isIndividualSchool} onChange={handleSchoolToggle}>
                  Project is an individual school
                </Checkbox>
              </FormControl>
            </GridItem>
            {accountingInfo.isIndividualSchool && (
              <GridItem colSpan={2}>
                <FormControl isRequired>
                  <FormLabel>School District Name</FormLabel>
                  <Input name="schoolDistrictName" value={accountingInfo.schoolDistrictName} onChange={handleChange} />
                </FormControl>
              </GridItem>
            )}
            <GridItem colSpan={2}>
              <FormControl>
                <FormLabel>Notes</FormLabel>
                <Textarea name="accountingNotes" value={accountingInfo.accountingNotes} onChange={handleChange} placeholder="Anything additional accounting should know" />
              </FormControl>
            </GridItem>
          </Grid>
        </VStack>
        <ButtonGroup w="100%" justifyContent="flex-end" mt={5}>
          <Button type="button" size="sm" colorScheme="blue" onClick={onPrev}>Previous</Button>
          <Button type="submit" size="sm" colorScheme="blue" isLoading={isSubmitting}>Next</Button>
        </ButtonGroup>
      </form>
    </Box>
  )
}

AccountingInfoStep.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  isSubmitting: PropTypes.bool
}
